module.exports = __webpack_public_path__ + "static/media/mail.ea521cae.svg";